// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LoginFormResetPasswordMutationVariables = Types.Exact<{
  email: Types.Scalars['String']['input'];
}>;

export type LoginFormResetPasswordMutation = {
  __typename?: 'Mutation';
  resetPassword: boolean;
};

export type LoginFormExistingAccountInfoQueryVariables = Types.Exact<{
  email: Types.Scalars['String']['input'];
}>;

export type LoginFormExistingAccountInfoQuery = {
  __typename?: 'Query';
  existingAccountInfo: {
    __typename?: 'ExistingAccountInfo';
    validatedEmail: string;
    authProvider?: Types.InternalAuthProvider | null;
  };
};

export const LoginFormResetPasswordDocument = gql`
  mutation LoginForm_ResetPassword($email: String!) {
    resetPassword(email: $email)
  }
`;
export type LoginFormResetPasswordMutationFn = Apollo.MutationFunction<
  LoginFormResetPasswordMutation,
  LoginFormResetPasswordMutationVariables
>;

/**
 * __useLoginFormResetPasswordMutation__
 *
 * To run a mutation, you first call `useLoginFormResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginFormResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginFormResetPasswordMutation, { data, loading, error }] = useLoginFormResetPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useLoginFormResetPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LoginFormResetPasswordMutation,
    LoginFormResetPasswordMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    LoginFormResetPasswordMutation,
    LoginFormResetPasswordMutationVariables
  >(LoginFormResetPasswordDocument, options);
}
export type LoginFormResetPasswordMutationHookResult = ReturnType<
  typeof useLoginFormResetPasswordMutation
>;
export type LoginFormResetPasswordMutationResult =
  Apollo.MutationResult<LoginFormResetPasswordMutation>;
export type LoginFormResetPasswordMutationOptions = Apollo.BaseMutationOptions<
  LoginFormResetPasswordMutation,
  LoginFormResetPasswordMutationVariables
>;
export const LoginFormExistingAccountInfoDocument = gql`
  query LoginForm_ExistingAccountInfo($email: String!) {
    existingAccountInfo(email: $email) {
      validatedEmail
      authProvider
    }
  }
`;

/**
 * __useLoginFormExistingAccountInfoQuery__
 *
 * To run a query within a React component, call `useLoginFormExistingAccountInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginFormExistingAccountInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginFormExistingAccountInfoQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useLoginFormExistingAccountInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    LoginFormExistingAccountInfoQuery,
    LoginFormExistingAccountInfoQueryVariables
  > &
    (
      | {
          variables: LoginFormExistingAccountInfoQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LoginFormExistingAccountInfoQuery,
    LoginFormExistingAccountInfoQueryVariables
  >(LoginFormExistingAccountInfoDocument, options);
}
export function useLoginFormExistingAccountInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LoginFormExistingAccountInfoQuery,
    LoginFormExistingAccountInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LoginFormExistingAccountInfoQuery,
    LoginFormExistingAccountInfoQueryVariables
  >(LoginFormExistingAccountInfoDocument, options);
}
export function useLoginFormExistingAccountInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LoginFormExistingAccountInfoQuery,
        LoginFormExistingAccountInfoQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LoginFormExistingAccountInfoQuery,
    LoginFormExistingAccountInfoQueryVariables
  >(LoginFormExistingAccountInfoDocument, options);
}
export type LoginFormExistingAccountInfoQueryHookResult = ReturnType<
  typeof useLoginFormExistingAccountInfoQuery
>;
export type LoginFormExistingAccountInfoLazyQueryHookResult = ReturnType<
  typeof useLoginFormExistingAccountInfoLazyQuery
>;
export type LoginFormExistingAccountInfoSuspenseQueryHookResult = ReturnType<
  typeof useLoginFormExistingAccountInfoSuspenseQuery
>;
export type LoginFormExistingAccountInfoQueryResult = Apollo.QueryResult<
  LoginFormExistingAccountInfoQuery,
  LoginFormExistingAccountInfoQueryVariables
>;
